import { businessAreasRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';
import { BusinessAreaModel } from '../domain';
import { BusinessAreaJson } from '../types';

export const useUpdateBusinessArea = () =>
  useMutation<BusinessAreaModel, unknown, BusinessAreaJson>((businessArea) =>
    businessAreasRepo.updateBusinessArea(businessArea),
  );
